// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"0676d30b","285":"c0eaf942","487":"d79f36af","607":"e8b9667c","751":"a6d0ead1","848":"28b0e4cf","884":"5fb1d195","967":"5be76565","971":"581b036c"}[chunkId] + ".chunk.js";
};